import React, { useRef, useEffect } from 'react';
import { Expandable, Attention, Button } from '@fabric-ds/react';
import pulse from '@finn-no/pulse-sdk';

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var TrackingType = /*#__PURE__*/function (TrackingType) {
  TrackingType[TrackingType["phoneNr"] = 0] = "phoneNr";
  TrackingType[TrackingType["sms"] = 1] = "sms";
  TrackingType[TrackingType["sendMelding"] = 2] = "sendMelding";
  return TrackingType;
}({});
var noopTracker = {
  phonenr: () => {},
  sms: () => {},
  moreAdsFrom: () => {},
  sendMelding: () => {},
  cta: () => {},
  link: () => {},
  homepage: () => {},
  openToggle: () => {}
};
var consoleTracker = position => ({
  /* eslint-disable no-console */
  phonenr: (adId, orgName) => {
    console.log("track 'phonenr' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  },
  sms: (adId, orgName) => {
    console.log("track 'sms' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  },
  moreAdsFrom: (adId, orgName) => {
    console.log("track 'moreAdsFrom' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  },
  sendMelding: (adId, orgName) => {
    console.log("track 'sendMelding' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  },
  cta: (adId, orgName) => {
    console.log("track 'cta' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  },
  link: (idx, adId, orgName) => {
    console.log("track 'link' (adId: ".concat(adId, " orgName: ").concat(orgName, ") idx ").concat(idx, " position: ").concat(position));
  },
  homepage: (adId, orgName) => {
    console.log("track 'homepage' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  },
  openToggle: (adId, orgName) => {
    console.log("track 'openToggle' (adId: ".concat(adId, " orgName: ").concat(orgName, ") position: ").concat(position));
  }
});
var pulseTracker = position => ({
  phonenr: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'Call',
      name: 'Contact seller',
      object: {
        id: 'phone-link',
        type: 'UIElement',
        elementType: 'Phone number',
        position
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Phone',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  sms: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'SMS',
      name: 'Contact seller',
      object: {
        id: 'sms-link',
        type: 'UIElement',
        elementType: 'Phone number',
        position
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Phone',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  moreAdsFrom: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'View',
      name: 'More ads from this organization',
      object: {
        id: 'more-ads-link',
        type: 'UIElement',
        elementType: 'Link',
        position
      },
      target: {
        id,
        type: 'Listing',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  sendMelding: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      name: 'Send message',
      type: 'Click',
      object: {
        id: 'send-msg-btn',
        type: 'UIElement',
        elementType: 'Button',
        position
      },
      target: {
        id,
        type: 'Message',
        provider: orgName
      },
      intent: 'Create'
    };
    pulse.trackEvent(pulsePayload);
  },
  cta: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      name: 'Extended profile action link',
      type: 'Click',
      object: {
        id: 'send-msg-btn',
        type: 'UIElement',
        elementType: 'Button',
        position
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: orgName
      },
      intent: 'Open'
    };
    pulse.trackEvent(pulsePayload);
  },
  link: (idx, adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      name: 'Extended profile link',
      type: 'Click',
      object: {
        id: 'send-msg-btn',
        type: 'UIElement',
        elementType: 'Button',
        name: "Link: ".concat(idx),
        position
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: orgName,
        position
      },
      intent: 'Open'
    };
    pulse.trackEvent(pulsePayload);
  },
  homepage: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'Open',
      name: 'Homepage link clicked',
      object: {
        id: 'homepage-link',
        type: 'UIElement',
        elementType: 'Link',
        position
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  openToggle: adId => {
    var pulsePayload = {
      type: 'Click',
      intent: 'Show',
      name: 'Open extended profile',
      object: {
        id: adId.toString(),
        type: 'UIElement',
        position
      }
    };
    pulse.trackEvent(pulsePayload);
  }
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var ensureExhaustiveMatch = param => noopTracker;
var resolveTracker = (trackerName, toggle) => {
  var position = toggle ? 'top' : 'right';
  switch (trackerName) {
    case 'noop':
      {
        return noopTracker;
      }
    case 'console':
      {
        return consoleTracker(position);
      }
    case 'pulse':
      {
        return pulseTracker(position);
      }
    default:
      {
        return ensureExhaustiveMatch();
      }
  }
};
function trackMeglerprofilButton(eventType, url, adId, orgId) {
  pulse.trackEvent({
    name: 'Meglerprofil link on ad',
    type: eventType,
    intent: eventType === 'Click' ? 'Open' : 'Show',
    object: {
      id: 'meglerprofil-link',
      name: orgId,
      type: 'UIElement',
      elementType: 'Button',
      hasExtendedProfile: true,
      items: [{
        type: 'ClassifiedAd',
        id: adId,
        contentId: adId,
        name: 'n/a',
        category: 'n/a',
        hasExtendedProfile: true
      }]
    },
    target: {
      id: url,
      type: 'Page',
      name: url.split('/').pop()
    },
    vertical: {
      name: 'realestate'
    }
  });
}

/* eslint-disable no-else-return */
function insertZeroWidthSpace(text) {
  // This function inserts zero width space if slash is in use.
  // This is to try to make stuff break prettier.
  // Previous attempt was using a step thing, e.g. every 10 chars,
  // but this does not make sense imo. Basically these texts should
  // never break though.

  if (!text) {
    return null;
  }
  var softHyphen = '\u200B';
  return text.replace('/', "".concat(softHyphen, "/").concat(softHyphen));
}
function calcRootStyles(props) {
  return {
    '--extended-profile-text-color': props.textColor,
    '--extended-profile-logo-bgcolor': props.logoBackgroundColor,
    '--extended-profile-cta-text-color': props.ctaColor.textColor,
    '--extended-profile-cta-bgcolor': props.ctaColor.backgroundColor,
    '--extended-profile-cta-bgcolor-hover': props.ctaColor.backgroundHoverColor,
    '--extended-profile-cta-text-color-hover': props.ctaColor.textHoverColor,
    '--extended-profile-cta-bgcolor-active': props.ctaColor.backgroundActiveColor,
    color: props.textColor
  };
}
var calcBoxingStyles = position => {
  var widths;
  if (position === 'top') {
    widths = '1px 1px 0 1px';
  } else if (position === 'bottom') {
    widths = '0 1px 1px 1px';
  } else {
    widths = '1px';
  }
  return {
    border: 'solid #C3CCD9',
    borderWidth: widths
  };
};
var definePhoneOrderingMobility = (adId, deviceType, email, phones) => {
  var mobileDevice = deviceType === 'mobile' || deviceType === 'tablet';
  var ret = phones && phones.reduce((accumulator, currentValue) => {
    var currentInfo = {
      link: currentValue.phoneAsLink,
      text: currentValue.phoneFormatted,
      trackingType: TrackingType.phoneNr
    };
    if (currentValue.type === 'MOBILE') {
      var smsLink = mobileDevice ? [{
        link: currentValue.phoneAsSmsLink,
        text: 'Send SMS',
        trackingType: TrackingType.sms
      }] : [];
      return [currentInfo, ...smsLink, ...accumulator];
    } else {
      return [...accumulator, currentInfo];
    }
  }, []);
  var sendMelding = {
    link: "/contact/".concat(adId),
    text: 'Send melding',
    trackingType: TrackingType.sendMelding
  };
  if (!email) {
    return ret;
  } else if (ret.length === 0) {
    return [sendMelding];
  } else if (!mobileDevice) {
    var [first, ...rest] = ret;
    return [first, sendMelding, ...rest];
  }
  return [...ret, sendMelding];
};
var definePhoneOrdering = (adId, contactIdx, deviceType, email, phones) => {
  var firstIsMobile = false;
  var mobileDevice = deviceType === 'mobile' || deviceType === 'tablet';
  var ret = phones.reduce((accumulator, currentValue) => {
    var currentInfo = {
      link: currentValue.phoneAsLink,
      text: currentValue.phoneFormatted,
      trackingType: TrackingType.phoneNr
    };
    if (!firstIsMobile && currentValue.type === 'MOBILE') {
      firstIsMobile = true;
      var smsLink = mobileDevice ? [{
        link: currentValue.phoneAsSmsLink,
        text: 'Send SMS',
        trackingType: TrackingType.sms
      }] : [];
      return [currentInfo, ...smsLink, ...accumulator];
    } else {
      return [...accumulator, currentInfo];
    }
  }, []);
  var sendMelding = {
    link: "/contact/".concat(adId, "?ci=").concat(contactIdx),
    text: 'Send melding',
    trackingType: TrackingType.sendMelding
  };
  if (!email) {
    return ret;
  } else if (ret.length === 0) {
    return [sendMelding];
  } else if (!mobileDevice) {
    var [first, ...rest] = ret;
    return [first, sendMelding, ...rest];
  }
  return [...ret, sendMelding];
};

var classes = {"extendedProfile":"ExtendedProfileBox-module_extendedProfile__BeMpX","extendedProfileLogo":"ExtendedProfileBox-module_extendedProfileLogo__4QIIy","extendedProfileLogoImg":"ExtendedProfileBox-module_extendedProfileLogoImg__gMqRK","extendedProfileLogoImgSmall":"ExtendedProfileBox-module_extendedProfileLogoImgSmall__rpAbq","headerSeparator":"ExtendedProfileBox-module_headerSeparator__Ifi-L","companyName":"ExtendedProfileBox-module_companyName__QzPMU","tplink":"ExtendedProfileBox-module_tplink__7QunD","extendedProfileCTA":"ExtendedProfileBox-module_extendedProfileCTA__jp-2I","contactImage":"ExtendedProfileBox-module_contactImage__CPJYO","buttonWithLargeClickTarget":"ExtendedProfileBox-module_buttonWithLargeClickTarget__-O1PA"};

function MeglerprofilButton(meglerprofilProps) {
  var meglerprofilRef = useRef(null);
  useEffect(() => {
    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          trackMeglerprofilButton('View', meglerprofilProps.url, meglerprofilProps.adId.toString(), meglerprofilProps.orgId.toString());
        }
      });
    });
    if (meglerprofilRef.current) {
      observer.observe(meglerprofilRef.current);
    }
    return () => {
      if (meglerprofilRef.current) {
        observer.unobserve(meglerprofilRef.current);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(Button, {
    ref: meglerprofilRef,
    className: classes.buttonWithLargeClickTarget,
    small: true,
    onClick: ( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (event) {
        event.preventDefault();
        trackMeglerprofilButton('Click', meglerprofilProps.url, meglerprofilProps.adId.toString(), meglerprofilProps.orgId.toString());
        window.open(meglerprofilProps.url, '_blank');
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }, /*#__PURE__*/React.createElement("div", {
    className: 'my-0 mx-2'
  }, "Profil"));
}
var renderContact$1 = (contact, adId, orgName, orgId, deviceType, tracker, idx, previewMode) => {
  var _contact$agentProfile;
  var phoneOrdering = definePhoneOrdering(adId, idx, deviceType, contact.email, contact.phone);
  var trackerF = trackingType => {
    switch (trackingType) {
      case TrackingType.phoneNr:
        return tracker === null || tracker === void 0 ? void 0 : tracker.phonenr;
      case TrackingType.sendMelding:
        return tracker === null || tracker === void 0 ? void 0 : tracker.sendMelding;
      case TrackingType.sms:
        return tracker === null || tracker === void 0 ? void 0 : tracker.sms;
      default:
        return null;
    }
  };
  var contactLinks = phoneOrdering.map((p, i) => /*#__PURE__*/React.createElement("a", {
    key: "custom-link".concat(i),
    className: "".concat(classes.tplink, " text-16"),
    rel: "nofollow",
    href: p.link,
    onClick: e => {
      if (previewMode) {
        e.preventDefault();
      } else {
        var _trackerF;
        (_trackerF = trackerF(p.trackingType)) === null || _trackerF === void 0 || _trackerF(adId, orgName);
      }
    }
  }, p.text));
  return /*#__PURE__*/React.createElement("div", {
    className: idx === 0 ? '' : 'mt-24',
    key: "contact-block-".concat(idx)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row relative items-center gap-16"
  }, contact.image && /*#__PURE__*/React.createElement("img", {
    className: "rounded-full mb-8 object-cover h-80 w-80 object-top ".concat(classes.contactImage, " border-white border-2"),
    alt: "Bilde av megler ".concat(contact.name),
    src: contact.image
  }), contact.agentProfileUrl && /*#__PURE__*/React.createElement("div", {
    className: 'absolute flex gap-16 flex-row bottom-0 pb-0 left-48 h-32'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex my-auto'
  }, /*#__PURE__*/React.createElement(MeglerprofilButton, {
    url: (_contact$agentProfile = contact.agentProfileUrl) !== null && _contact$agentProfile !== void 0 ? _contact$agentProfile : '',
    adId: adId,
    orgId: orgId
  })), /*#__PURE__*/React.createElement(Attention, {
    placement: 'right',
    callout: true,
    isShowing: true
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '-2px',
      marginBottom: '-2px'
    },
    className: 'text-primary text-12'
  }, "Nyhet!")))), /*#__PURE__*/React.createElement("h3", {
    "aria-label": "Kontaktperson",
    className: "mb-4 text-16 pt-16"
  }, contact.name), /*#__PURE__*/React.createElement("div", {
    className: "text-14 break-words"
  }, contact.title ? /*#__PURE__*/React.createElement("p", null, contact.title) : /*#__PURE__*/React.createElement(React.Fragment, null)), /*#__PURE__*/React.createElement("div", {
    className: "grid f-grid grid-cols-2 gap-y-8 gap-x-32 whitespace-nowrap"
  }, contactLinks));
};
var renderLogo$1 = function renderLogo(logo) {
  var small = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex align-items justify-center rounded-t-8 ".concat(small ? 'py-8 px-16' : 'p-16', " ").concat(classes.extendedProfileLogo),
    style: calcBoxingStyles('top')
  }, /*#__PURE__*/React.createElement("img", {
    className: "".concat(small ? classes.extendedProfileLogoImgSmall : classes.extendedProfileLogoImg, " object-contain object-center"),
    src: logo,
    alt: "Logo"
  }));
};
var renderBody$1 = _ref2 => {
  var {
    orgName,
    orgId,
    contacts,
    suppressMoreAdsFrom,
    moreFromLink,
    deviceType,
    adId,
    cta,
    customLinks,
    tracker,
    homepageUrl,
    previewMode
  } = _ref2;
  var hasLinks = homepageUrl || !suppressMoreAdsFrom || customLinks && customLinks.length > 0;
  var hasBody = hasLinks || cta || contacts && contacts.length > 0;
  if (hasBody) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mb-16"
    }, contacts.map((contact, idx) => renderContact$1(contact, adId, orgName, orgId, deviceType, tracker, idx, previewMode)), hasLinks && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mt-16"
    }, homepageUrl && /*#__PURE__*/React.createElement("a", {
      className: "".concat(classes.tplink, " text-16 mt-16"),
      href: homepageUrl,
      rel: "nofollow",
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.homepage(adId, orgName);
        }
      }
    }, "Hjemmeside"), !suppressMoreAdsFrom && /*#__PURE__*/React.createElement("a", {
      href: moreFromLink,
      className: "".concat(classes.tplink, " text-16 mt-16"),
      rel: "nofollow",
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.moreAdsFrom(adId, orgName);
        }
      }
    }, "Flere annonser fra annons\xF8r"), customLinks.map((link, idx) => /*#__PURE__*/React.createElement("a", {
      key: link.text,
      className: "".concat(classes.tplink, " text-16 mt-16"),
      href: link.url,
      rel: "nofollow",
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.link(idx, adId, orgName);
        }
      }
    }, link.text))), cta && /*#__PURE__*/React.createElement("div", {
      className: "mt-32"
    }, /*#__PURE__*/React.createElement("a", {
      href: cta.url,
      rel: "nofollow",
      className: "".concat(classes.extendedProfileCTA, " button button--cta w-full max-w-none"),
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.cta(adId, orgName);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: 'overflow-hidden whitespace-nowrap',
      style: {
        textOverflow: 'ellipsis'
      }
    }, cta.text))));
  }
  return /*#__PURE__*/React.createElement("div", null);
};
var RealEstateExtendedProfileToggle = props => {
  var {
    logo,
    orgName,
    slogan,
    contacts,
    tracker,
    adId,
    colors
  } = props;
  var rootStyles = calcRootStyles(colors);
  var bottomStyle = calcBoxingStyles(logo ? 'bottom' : 'both');
  var onlyFirstContact = contacts.length > 0 ? [contacts[0]] : [];
  var roudingClass = logo ? 'rounded-b-8' : 'rounded-8';
  var [open, setOpen] = React.useState(false);
  var setOpenWithTracking = openExpandable => {
    if (openExpandable) {
      tracker === null || tracker === void 0 || tracker.openToggle(adId, orgName);
    }
    setOpen(openExpandable);
  };
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    style: rootStyles,
    className: "".concat(classes.extendedProfile, " rounded-8")
  }, logo && renderLogo$1(logo, true), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2(_objectSpread2({}, bottomStyle), {}, {
      backgroundColor: colors.backgroundColor || ''
    }),
    className: "".concat(roudingClass)
  }, logo && /*#__PURE__*/React.createElement("hr", {
    className: "".concat(classes.headerSeparator, " ")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.expandArea)
  }, /*#__PURE__*/React.createElement(Expandable, {
    title: /*#__PURE__*/React.createElement("span", {
      style: {
        hyphens: 'manual',
        overflowWrap: 'break-word'
      }
    }, insertZeroWidthSpace(slogan) || insertZeroWidthSpace(orgName)),
    box: true,
    animated: true,
    chevron: true,
    expanded: open,
    onChange: setOpenWithTracking
  }, renderBody$1(_objectSpread2(_objectSpread2({}, props), {}, {
    contacts: onlyFirstContact
  }))))));
};
var RealEstateExtendedProfileNoToggle = props => {
  var {
    logo,
    orgName,
    slogan,
    colors
  } = props;
  var rootStyles = calcRootStyles(colors);
  var bottomStyle = calcBoxingStyles(logo ? 'bottom' : 'both');
  var roundedStyle = logo ? 'rounded-b-8' : 'rounded-8';
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    style: rootStyles,
    className: "".concat(classes.extendedProfile)
  }, logo && renderLogo$1(logo), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2(_objectSpread2({}, bottomStyle), {}, {
      backgroundColor: colors.backgroundColor || ''
    }),
    className: roundedStyle
  }, logo && /*#__PURE__*/React.createElement("hr", {
    className: "".concat(classes.headerSeparator, " ")
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-16 pt-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-24"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.companyName, " font-normal text-16 mb-8")
  }, insertZeroWidthSpace(orgName)), slogan && /*#__PURE__*/React.createElement("div", {
    className: "text-14"
  }, insertZeroWidthSpace(slogan))), renderBody$1(props))));
};
var RealEstateExtendedProfile = props => {
  var tracker = props.trackerName ? resolveTracker(props.trackerName, props.withToggle === true) : undefined;
  var component = props.withToggle ? RealEstateExtendedProfileToggle : RealEstateExtendedProfileNoToggle;
  return component(_objectSpread2(_objectSpread2({}, props), {}, {
    tracker
  }));
};

var renderContact = (contact, adId, orgName, orgId, deviceType, tracker, previewMode) => {
  var phoneOrdering = definePhoneOrderingMobility(adId, deviceType, contact.email, contact.phone);
  var trackerF = trackingType => {
    switch (trackingType) {
      case TrackingType.phoneNr:
        return tracker === null || tracker === void 0 ? void 0 : tracker.phonenr;
      case TrackingType.sendMelding:
        return tracker === null || tracker === void 0 ? void 0 : tracker.sendMelding;
      case TrackingType.sms:
        return tracker === null || tracker === void 0 ? void 0 : tracker.sms;
      default:
        return null;
    }
  };
  var contactLinks = phoneOrdering && phoneOrdering.map((p, i) => /*#__PURE__*/React.createElement("a", {
    key: "custom-link".concat(i),
    className: "".concat(classes.tplink, " text-16"),
    rel: "nofollow",
    href: p.link,
    onClick: e => {
      if (previewMode) {
        e.preventDefault();
      } else {
        var _trackerF;
        (_trackerF = trackerF(p.trackingType)) === null || _trackerF === void 0 || _trackerF(adId, orgName);
      }
    }
  }, p.text));
  return /*#__PURE__*/React.createElement("div", {
    key: "contact-block"
  }, /*#__PURE__*/React.createElement("h3", {
    "aria-label": "Kontaktperson",
    className: "mb-4 text-16 pt-16"
  }, contact.name), /*#__PURE__*/React.createElement("div", {
    className: "grid f-grid grid-cols-2 gap-y-8 gap-x-32 whitespace-nowrap"
  }, contactLinks), contact.url && /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement("a", {
    key: contact.url,
    className: "".concat(classes.tplink),
    href: contact.url,
    rel: "nofollow",
    onClick: e => {
      if (previewMode) {
        e.preventDefault();
      } else {
        tracker === null || tracker === void 0 || tracker.homepage(adId, orgName);
      }
    }
  }, "Hjemmeside")));
};
var renderCta = (orgName, adId, cta, tracker, previewMode) => /*#__PURE__*/React.createElement("a", {
  href: cta.url,
  rel: "nofollow",
  className: "".concat(classes.extendedProfileCTA, " button button--cta w-full max-w-none"),
  onClick: e => {
    if (previewMode) {
      e.preventDefault();
    } else {
      tracker === null || tracker === void 0 || tracker.cta(adId, orgName);
    }
  }
}, /*#__PURE__*/React.createElement("div", {
  className: 'overflow-hidden whitespace-nowrap',
  style: {
    textOverflow: 'ellipsis'
  }
}, cta.text));
var renderLogo = function renderLogo(logo) {
  var small = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex align-items justify-center rounded-t-8 ".concat(small ? 'py-8 px-16' : 'p-16', " ").concat(classes.extendedProfileLogo),
    style: calcBoxingStyles('top')
  }, /*#__PURE__*/React.createElement("img", {
    className: "".concat(small ? classes.extendedProfileLogoImgSmall : classes.extendedProfileLogoImg, " object-contain object-center"),
    src: logo,
    alt: "Logo"
  }));
};
var getMembershipText = memberShip => {
  switch (memberShip) {
    case 'NBF':
      return 'Medlem av Norges Bilbransjeforbund';
    case 'NCB':
      return 'Autorisert NCB-forhandler';
    case 'Norboat':
      return 'Medlem av Norboat';
    case 'NMCF':
      return 'Medlem av NMCF';
    default:
      throw new Error("Unhandled Membership case: ".concat(memberShip));
  }
};
var renderBody = _ref => {
  var {
    orgName,
    orgId,
    contact,
    suppressMoreAdsFrom,
    moreFromLink,
    deviceType,
    adId,
    cta,
    customLinks,
    tracker,
    homepageUrl,
    previewMode,
    membershipLink
  } = _ref;
  var hasLinks = homepageUrl || !suppressMoreAdsFrom || customLinks && customLinks.length > 0 || membershipLink;
  var hasBody = hasLinks || cta || contact;
  if (hasBody) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mb-16"
    }, renderContact(contact, adId, orgName, orgId, deviceType, tracker, previewMode), hasLinks && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mt-16"
    }, !contact.url && homepageUrl && /*#__PURE__*/React.createElement("a", {
      className: "".concat(classes.tplink, " text-16 mt-16"),
      href: homepageUrl,
      rel: "nofollow",
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.homepage(adId, orgName);
        }
      }
    }, "Hjemmeside"), !suppressMoreAdsFrom && /*#__PURE__*/React.createElement("a", {
      href: moreFromLink,
      className: "".concat(classes.tplink, " text-16 mt-16"),
      rel: "nofollow",
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.moreAdsFrom(adId, orgName);
        }
      }
    }, "Flere annonser fra oss"), membershipLink && /*#__PURE__*/React.createElement("a", {
      key: membershipLink.membership,
      className: "".concat(classes.tplink, " text-16 mt-16"),
      href: membershipLink.link,
      rel: "nofollow"
    }, getMembershipText(membershipLink.membership)), customLinks.map((link, idx) => /*#__PURE__*/React.createElement("a", {
      key: link.text,
      className: "".concat(classes.tplink, " text-16 mt-16"),
      href: link.url,
      rel: "nofollow",
      onClick: e => {
        if (previewMode) {
          e.preventDefault();
        } else {
          tracker === null || tracker === void 0 || tracker.link(idx, adId, orgName);
        }
      }
    }, link.text))), cta && /*#__PURE__*/React.createElement("div", {
      className: "mt-32"
    }, renderCta(orgName, adId, cta, tracker, previewMode)));
  }
  return /*#__PURE__*/React.createElement("div", null);
};
var MobilityExtendedProfileToggle = props => {
  var {
    logo,
    orgName,
    slogan,
    contact,
    tracker,
    adId,
    colors,
    cta
  } = props;
  var rootStyles = calcRootStyles(colors);
  var bottomStyle = calcBoxingStyles(logo ? 'bottom' : 'both');
  var roudingClass = logo ? 'rounded-b-8' : 'rounded-8';
  var [open, setOpen] = React.useState(false);
  var setOpenExpandable = openExpandable => {
    if (openExpandable) {
      tracker === null || tracker === void 0 || tracker.openToggle(adId, orgName);
    }
    setOpen(openExpandable);
  };
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    style: rootStyles,
    className: "".concat(classes.extendedProfile, " rounded-8")
  }, logo && renderLogo(logo, true), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2(_objectSpread2({}, bottomStyle), {}, {
      backgroundColor: colors.backgroundColor || ''
    }),
    className: "".concat(roudingClass)
  }, logo && /*#__PURE__*/React.createElement("hr", {
    className: "".concat(classes.headerSeparator, " ")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.expandArea)
  }, /*#__PURE__*/React.createElement(Expandable, {
    title: !open && cta ? /*#__PURE__*/React.createElement("div", {
      className: 'flex-1 overflow-hidden whitespace-nowrap mr-16',
      style: {
        textOverflow: 'ellipsis'
      }
    }, renderCta(orgName, adId, cta, tracker, props.previewMode)) : /*#__PURE__*/React.createElement("span", {
      style: {
        hyphens: 'manual',
        overflowWrap: 'break-word'
      }
    }, insertZeroWidthSpace(slogan) || insertZeroWidthSpace(orgName)),
    box: true,
    animated: true,
    chevron: true,
    expanded: open,
    onChange: setOpenExpandable
  }, renderBody(_objectSpread2(_objectSpread2({}, props), {}, {
    contact
  }))))));
};
var MobilityExtendedProfileNoToggle = props => {
  var {
    logo,
    orgName,
    slogan,
    colors
  } = props;
  var rootStyles = calcRootStyles(colors);
  var bottomStyle = calcBoxingStyles(logo ? 'bottom' : 'both');
  var roundedStyle = logo ? 'rounded-b-8' : 'rounded-8';
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    style: rootStyles,
    className: "".concat(classes.extendedProfile)
  }, logo && renderLogo(logo), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2(_objectSpread2({}, bottomStyle), {}, {
      backgroundColor: colors.backgroundColor || ''
    }),
    className: roundedStyle
  }, logo && /*#__PURE__*/React.createElement("hr", {
    className: "".concat(classes.headerSeparator, " ")
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-16 pt-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-24"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.companyName, " font-normal text-16 mb-8")
  }, insertZeroWidthSpace(orgName)), slogan && /*#__PURE__*/React.createElement("div", {
    className: "text-14"
  }, insertZeroWidthSpace(slogan))), renderBody(props))));
};
var MobilityExtendedProfile = props => {
  var tracker = props.trackerName ? resolveTracker(props.trackerName, props.withToggle === true) : undefined;
  var component = props.withToggle ? MobilityExtendedProfileToggle : MobilityExtendedProfileNoToggle;
  return component(_objectSpread2(_objectSpread2({}, props), {}, {
    tracker
  }));
};

export { MobilityExtendedProfile, RealEstateExtendedProfile };
//# sourceMappingURL=index.js.map
